<div *ngIf="navData" fxLayoutGap="10px" class="data-wrap pt-0" fxLayout="column">
    <div class="title mt-0" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-icon class="title-icon dark-blue {{ navData.data.class }}">{{ navData.data.icon }}</mat-icon>
        <div class="title-label dark-blue {{ navData.data.class }}" fxFlex="grow">{{ navData.data.title }}</div>
    </div>

    <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
        <app-image-view
            [ngStyle]="{ minWidth: '110px' }"
            [media_id]="navData.data.resource.media"
            paddingBottom="70px"
        ></app-image-view>
        <div fxLayout="column" fxLayoutAlign="center start">
            <span class="dark-blue res-title">{{ navData.data.resource.title }}</span>
            <!-- <div *ngIf="!navData.data.resource.price || navData.data.resource.price === 0" class="price-wrap">
                <div class="dark-blue-color">FREE!</div>
            </div> -->
            <!-- <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3px" class="small signoff-date"
                ><span i18n>Requested at</span> <span>{{ navData.data.enrollment.requested_at }}</span></span
            > -->
        </div>
    </div>
    <app-occasions-dates-viewer
        [dates]="navData.data.resource.user_collaboration?.enroll_approval_required?.metadata?.occasion_dates"
        [canShowMore]="false"
        [timeZone]="navData.data.resource.time_zone"
    ></app-occasions-dates-viewer>

    <div *ngIf="!!navData.data.inputDesc" class="input-field-parent" fxLayout="column" fxLayoutGap="5px">
        <span>{{ navData.data.inputDesc }}</span>
        <mat-form-field cdkTrapFocus appearance="outline" floatLabel="never" class="w-100" fxFlex="grow">
            <textarea
                cdkFocusInitial
                #taskInput
                matInput
                type="text"
                [formControl]="value"
                placeholder="Message to the admin"
                i18n-placeholder
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="50"
                required
            ></textarea>
        </mat-form-field>
    </div>
    <ng-container [ngTemplateOutlet]="actions"></ng-container>
</div>

<ng-template #actions>
    <div
        *ngIf="!!navData.data.actions?.length"
        class="action"
        fxLayout="row-reverse"
        fxLayoutAlign="start center"
        fxLayoutGap="10px"
    >
        <ng-container *ngFor="let action of navData.data.actions">
            <button
                fxFlex="0 0 auto"
                class="mobile-button positive {{ action.class }}"
                (click)="
                    onClose.emit(
                        action.value
                            ? {
                                  data: { type: navData.data.type, response: action.value, value: value.value }
                              }
                            : null
                    )
                "
                mat-button
                i18n
            >
                {{ action.label }}
            </button>
        </ng-container>
        <!-- <button fxHide fxFlex="0 0 auto" class="mobile-button sona" (click)="onClose.emit(null)" mat-button i18n>
            Start in Sona AI tutor
        </button> -->
    </div>
</ng-template>
